import React from "react";
import { EditRecordviewTile } from "../../Pages/ApplicationBlock/ChartRenderer/BlockTiles";
import { EditRecordviewChart } from "../../Pages/ApplicationBlock/RecordsViewRenderer/Desktop/NewDesktopRecordviewRenderer";
import EditFieldColumn from "../../Pages/ApplicationBlock/RecordsViewRenderer/Desktop/RecordsViewEdit/Columns/EditFieldColumn";
import EditBlock from "../EditComponents/EditBlock";
import EditButtonGroup from "../EditComponents/EditButtonGroup";
import EditDownloadFileManager from "../EditComponents/EditDownloadFileManager";
import { EditFieldForPositionedScreen } from "../EditComponents/EditField";
import EditFileViewer from "../EditComponents/EditFileViewer";
import EditFormBlock from "../EditComponents/EditFormBlock";
import EditHtmlContent from "../EditComponents/EditHtmlContent";
import EditImageConfig from "../EditComponents/EditImageConfig";
import EditLabel from "../EditComponents/EditLabel";
import EditMailThread from "../EditComponents/EditMailThread";
import EditMapElement from "../EditComponents/EditMapElement";
import EditPositionButtonConfig from "../EditComponents/EditPositionButtonConfig";
import EditPositionedTab from "../EditComponents/EditPositionedTab";
import EditPositionSection from "../EditComponents/EditPositionSection";
import EditProgressBar from "../EditComponents/EditProgressBar";
import EditProgressTracker from "../EditComponents/EditProgressTracker";
import EditRecordviewTable from "../EditComponents/EditRecordviewTable";
import EditRvActionsListForPosition from "../EditComponents/EditRvActionsListForPosition";
import EditRVColumnsManager from "../EditComponents/EditRVColumnsManager";
import EditRvTabFilterForPosition from "../EditComponents/EditRvTabFilterForPosition";
import EditRVTableCatalogToggler from "../EditComponents/EditRVTableCatalogToggler";
import EditSearchBox from "../EditComponents/EditSearchBox";
import EditSeparator from "../EditComponents/EditSeparator";
import EditSpacer from "../EditComponents/EditSpacer";
import EditReactComponent from "../EditComponents/EditReactComponent";
import EditDvGroup from "../EditComponents/EditDvGroup";
import EditIcon from "../EditComponents/EditIcon";
import EditRvFilterForPosition from "../EditComponents/EditRvFilterForPosition";
import EditCustomColumn from "../EditComponents/EditCustomColumn";
import EditTableColumnCell from "../EditComponents/EditTableColumnCell";
import EditTableRowCell from "../EditComponents/EditTableRowCell";
import EditTableForPositioned from "../EditComponents/EditTableForPositioned";
import EditJsonToTable from "../EditComponents/EditJsonToTable";
import EditFilePreview from "../EditComponents/EditFilePreview";

const EditElementComponent = ({
  elements,
  editElementData,
  setEditElementData,
  saveElement,
  smId,
  device,
  tableType,
  handleClasses,
  elementType,
  elementSubType,
  jobPlaces,
  targetFolderPath
}) => {
  const getEditElementComponent = () => {
    switch (elementType) {
      case "button":
      case "dropdown":
        return (
          <EditPositionButtonConfig
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={smId}
            tableType={tableType}
            places={jobPlaces}
            type={elementType}
            device={device}
            actionElements={elements}
          />
        );
      case "rv_action_button":
      case "rv_action_dropdown":
        const newElementType = elementType === "rv_action_button" ? "button" : "dropdown";
        return (
          <EditPositionButtonConfig
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={smId}
            tableType={tableType}
            places="records_view_header"
            type={newElementType}
            device={device}
            actionElements={elements}
          />
        );
      case "html":
      case "dynamic-html":
        return (
          <EditHtmlContent
            editElementData={editElementData}
            setEditElementData={saveElement}
            tableID={smId}
            places="details_view"
            element="button"
            device={device}
          />
        );
      case "image":
        return <EditImageConfig editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "label":
        return <EditLabel editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "field":
      case "variable":
        return (
          <EditFieldForPositionedScreen
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={smId}
            device={device}
            targetFolderPath={targetFolderPath}
          />
        );
      case "section":
        return (
          <EditPositionSection
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableId={smId}
            tableType={tableType}
          />
        );
      case "block":
      case "column":
        return (
          <EditBlock
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableId={smId}
            tableType={tableType}
            jobPlaces={jobPlaces}
            device={device}
          />
        );
      case "spacer":
        return <EditSpacer editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "mail_thread":
        return (
          <EditMailThread editElementData={editElementData} setEditElementData={setEditElementData} tableID={smId} />
        );
      case "tab":
        return <EditPositionedTab editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "file_viewer":
        return (
          <EditFileViewer editElementData={editElementData} setEditElementData={setEditElementData} tableID={smId} />
        );
      case "file_preview":
        return (
          <EditFilePreview editElementData={editElementData} setEditElementData={setEditElementData} tableID={smId} />
        );
      case "button-group":
        return (
          <EditButtonGroup
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            elements={elements}
            smId={smId}
            device={device}
            places="details_view"
            tableType={tableType}
          />
        );
      case "dv-group":
        return (
          <EditDvGroup
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            smId={smId}
            device={device}
            positionClasses={true}
            tableType={tableType}
          />
        );
      case "form":
        return (
          <EditFormBlock
            editElementData={editElementData}
            setEditElementData={saveElement}
            device={device}
            elements={elements}
            tableID={smId}
            places="details_view"
            flag={true}
            handleClasses={handleClasses}
            type={tableType}
          />
        );
      case "progress-bar":
        return (
          <EditProgressBar editElementData={editElementData} setEditElementData={setEditElementData} tableID={smId} />
        );
      case "progress-tracker":
        return (
          <EditProgressTracker
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={smId}
          />
        );
      case "custom-component":
        return (
          <EditReactComponent
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableType={tableType}
            tableId={smId}
          />
        );
      case "icon":
        return <EditIcon editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "separator":
        return (
          <div>
            <EditSeparator editElementData={editElementData} setEditElementData={setEditElementData} />
          </div>
        );
      case "table":
        switch (elementSubType) {
          case "edit_column_cell":
            return <EditTableColumnCell editElementData={editElementData} setEditElementData={setEditElementData} />;
          case "edit_row_cell":
            return (
              <EditTableRowCell
                editElementData={editElementData}
                setEditElementData={setEditElementData}
                tableId={smId}
                device={device}
              />
            );
          default:
            return <EditTableForPositioned editElementData={editElementData} setEditElementData={setEditElementData} />;
        }
      case "json_to_table":
        return (
          <EditJsonToTable
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableId={smId}
            device={device}
            tableType={tableType}
          />
        );
      case "rv_table":
        switch (elementSubType) {
          case "edit_column":
            switch (editElementData.type) {
              case "custom":
                return (
                  <EditCustomColumn
                    column={editElementData}
                    handleChangeColumn={setEditElementData}
                    tableId={smId}
                    tableType={tableType}
                    device={device}
                  />
                );

              default:
                return (
                  <EditFieldColumn
                    field={editElementData}
                    tableId={smId}
                    tableType={tableType}
                    handleChangeField={setEditElementData}
                  />
                );
            }
          default:
            return (
              <EditRecordviewTable
                editElementData={editElementData}
                setEditElementData={setEditElementData}
                device={device}
              />
            );
        }
      case "chart_tile":
      case "rv_tile":
        return (
          <EditRecordviewTile
            tile={editElementData}
            handleChangeSingletile={setEditElementData}
            tableId={smId}
            tableType={tableType}
          />
        );
      case "rv_chart":
      case "chart":
        return (
          <EditRecordviewChart
            chart={editElementData}
            saveChartConfig={setEditElementData}
            tableId={smId}
            tableType={tableType}
          />
        );
      case "chart_filters":
      case "rv_filters":
        return (
          <EditRvFilterForPosition
            setEditElementData={setEditElementData}
            editElementData={editElementData}
            tableId={smId}
            tableType={tableType}
          />
        );
      case "rv_actions_list":
        return (
          <EditRvActionsListForPosition
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            elements={elements}
            tableId={smId}
            tableType={tableType}
            device={device}
            places="records_view_header"
          />
        );
      case "rv_tab_filters":
        return (
          <EditRvTabFilterForPosition
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableId={smId}
            tableType={tableType}
          />
        );
      case "search_box":
        return <EditSearchBox setEditElementData={setEditElementData} editElementData={editElementData} />;
      case "rv_columns_manager":
        return <EditRVColumnsManager setEditElementData={setEditElementData} editElementData={editElementData} />;
      case "rv_table_catalog_toggler":
        return <EditRVTableCatalogToggler setEditElementData={setEditElementData} editElementData={editElementData} />;
      case "download_file":
        return <EditDownloadFileManager setEditElementData={setEditElementData} editElementData={editElementData} />;
      case "map":
        return (
          <EditMapElement
            setEditElementData={setEditElementData}
            editElementData={editElementData}
            tableId={smId}
            tableType={tableType}
          />
        );
      default:
        return <div className="">Nothing to edit here</div>;
    }
  };

  return <div>{getEditElementComponent()}</div>;
};
export default EditElementComponent;
